import { jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';

const Label = styled(Typography) `
  ${({ theme }) => `
  padding-left: ${theme.spacing(3)};
  color: ${theme.palette.N30.main};
  `};
`;
const GroupHeading = ({ data: { label } }) => (jsx(Label, Object.assign({ variant: "subtitle2", "data-testid": `group-heading-${label}` }, { children: label })));

export { GroupHeading as default };
//# sourceMappingURL=GroupHeading.js.map
